/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Range } from "./range";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ThermalParams {
  validRangeC: Range | undefined;
  warningRangeC: Range | undefined;
  saturationRangeC: Range | undefined;
  clipRangeC: Range | undefined;
  emissivity: number;
  relativeHumidity: number;
  objectDistanceM: number;
}

function createBaseThermalParams(): ThermalParams {
  return {
    validRangeC: undefined,
    warningRangeC: undefined,
    saturationRangeC: undefined,
    clipRangeC: undefined,
    emissivity: 0,
    relativeHumidity: 0,
    objectDistanceM: 0,
  };
}

export const ThermalParams = {
  encode(message: ThermalParams, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.validRangeC !== undefined) {
      Range.encode(message.validRangeC, writer.uint32(10).fork()).ldelim();
    }
    if (message.warningRangeC !== undefined) {
      Range.encode(message.warningRangeC, writer.uint32(18).fork()).ldelim();
    }
    if (message.saturationRangeC !== undefined) {
      Range.encode(message.saturationRangeC, writer.uint32(26).fork()).ldelim();
    }
    if (message.clipRangeC !== undefined) {
      Range.encode(message.clipRangeC, writer.uint32(34).fork()).ldelim();
    }
    if (message.emissivity !== 0) {
      writer.uint32(45).float(message.emissivity);
    }
    if (message.relativeHumidity !== 0) {
      writer.uint32(53).float(message.relativeHumidity);
    }
    if (message.objectDistanceM !== 0) {
      writer.uint32(61).float(message.objectDistanceM);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ThermalParams {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThermalParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.validRangeC = Range.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.warningRangeC = Range.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.saturationRangeC = Range.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.clipRangeC = Range.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.emissivity = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.relativeHumidity = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.objectDistanceM = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThermalParams {
    return {
      validRangeC: isSet(object.validRangeC) ? Range.fromJSON(object.validRangeC) : undefined,
      warningRangeC: isSet(object.warningRangeC) ? Range.fromJSON(object.warningRangeC) : undefined,
      saturationRangeC: isSet(object.saturationRangeC) ? Range.fromJSON(object.saturationRangeC) : undefined,
      clipRangeC: isSet(object.clipRangeC) ? Range.fromJSON(object.clipRangeC) : undefined,
      emissivity: isSet(object.emissivity) ? globalThis.Number(object.emissivity) : 0,
      relativeHumidity: isSet(object.relativeHumidity) ? globalThis.Number(object.relativeHumidity) : 0,
      objectDistanceM: isSet(object.objectDistanceM) ? globalThis.Number(object.objectDistanceM) : 0,
    };
  },

  toJSON(message: ThermalParams): unknown {
    const obj: any = {};
    if (message.validRangeC !== undefined) {
      obj.validRangeC = Range.toJSON(message.validRangeC);
    }
    if (message.warningRangeC !== undefined) {
      obj.warningRangeC = Range.toJSON(message.warningRangeC);
    }
    if (message.saturationRangeC !== undefined) {
      obj.saturationRangeC = Range.toJSON(message.saturationRangeC);
    }
    if (message.clipRangeC !== undefined) {
      obj.clipRangeC = Range.toJSON(message.clipRangeC);
    }
    if (message.emissivity !== 0) {
      obj.emissivity = message.emissivity;
    }
    if (message.relativeHumidity !== 0) {
      obj.relativeHumidity = message.relativeHumidity;
    }
    if (message.objectDistanceM !== 0) {
      obj.objectDistanceM = message.objectDistanceM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ThermalParams>, I>>(base?: I): ThermalParams {
    return ThermalParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ThermalParams>, I>>(object: I): ThermalParams {
    const message = createBaseThermalParams();
    message.validRangeC = (object.validRangeC !== undefined && object.validRangeC !== null)
      ? Range.fromPartial(object.validRangeC)
      : undefined;
    message.warningRangeC = (object.warningRangeC !== undefined && object.warningRangeC !== null)
      ? Range.fromPartial(object.warningRangeC)
      : undefined;
    message.saturationRangeC = (object.saturationRangeC !== undefined && object.saturationRangeC !== null)
      ? Range.fromPartial(object.saturationRangeC)
      : undefined;
    message.clipRangeC = (object.clipRangeC !== undefined && object.clipRangeC !== null)
      ? Range.fromPartial(object.clipRangeC)
      : undefined;
    message.emissivity = object.emissivity ?? 0;
    message.relativeHumidity = object.relativeHumidity ?? 0;
    message.objectDistanceM = object.objectDistanceM ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
